import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ResponsiveContainer,
  ResponsiveHeader,
  ResponsiveContent,
  ResponsiveFooter,
} from "../ui/ResponsiveLayout";

const Frame241: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResponsiveContainer>
      <ResponsiveContent>
        <ResponsiveHeader title="Plan for Your Pets and Dependents" />

        <div className="max-w-4xl space-y-8">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              The people and pets who depend on you rely on clear guidance if
              something unexpected happens. This section helps you document care
              instructions, preferences, and important details so those you
              trust can step in with confidence and compassion when it matters
              most.
            </p>
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              You don’t need to have everything figured out today — even small
              details can make a meaningful difference later.
            </p>
          </div>

          {/* What You'll Do */}
          <div className="bg-white rounded-lg border border-neutral-200 p-6">
            <h2 className="text-xl font-semibold text-cyan-900 mb-4">
              What You’ll Do
            </h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  1
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Add information about your pets and dependent family members
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  2
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Document care routines, medical needs, and special
                    considerations
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  3
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Identify trusted caregivers and important contacts
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  4
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Record financial arrangements and care-related instructions
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  5
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Leave clear notes and messages for those who will be
                    providing care
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-cyan-50 border border-cyan-100 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-cyan-900 mb-3">
              Why This Matters
            </h2>
            <ul className="space-y-2 text-stone-700">
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Reduces stress and uncertainty for caregivers during emotional
                  moments
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Helps ensure pets and dependents receive consistent, familiar
                  care
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Prevents gaps in care caused by missing or unclear information
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Gives you peace of mind knowing your loved ones are protected
                  and understood
                </span>
              </li>
            </ul>
          </div>

          {/* Estimated Time */}
          <div className="text-center text-stone-600">
            <p className="text-sm">
              <span className="font-semibold">Estimated time:</span>{" "}
              Approximately 30–40 minutes, depending on the number of pets and
              dependents you’d like to include.
            </p>
          </div>
        </div>
      </ResponsiveContent>

      <ResponsiveFooter
        title="Plan for Your Pets and Dependents"
        subtitle="Plan care for pets and dependents who rely on you"
        progressPercent={0}
        onBack={() => navigate("/frame-140")}
        onNext={() => navigate("/frame-242")}
        nextText="Get Started"
        backText="Back to Dashboard"
      />
    </ResponsiveContainer>
  );
};

export default Frame241;